import { render, staticRenderFns } from "./dynamic.vue?vue&type=template&id=a5d3a1de&scoped=true"
import script from "./dynamic.vue?vue&type=script&lang=js"
export * from "./dynamic.vue?vue&type=script&lang=js"
import style0 from "./dynamic.vue?vue&type=style&index=0&id=a5d3a1de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d3a1de",
  null
  
)

export default component.exports